import React from 'react';
import { formatDateTime, truncateUuid } from './profileUtils';

const COPY = {
  en: {
    userIdLabel: 'User ID',
    memberSinceLabel: 'Member since',
    lastUpdatedLabel: 'Last updated',
    copy: 'Copy',
    copied: 'User ID copied',
  },
  zh: {
    userIdLabel: '用户 ID',
    memberSinceLabel: '注册时间',
    lastUpdatedLabel: '最近更新',
    copy: '复制',
    copied: '已复制用户 ID',
  },
};

function CopyIcon() {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" fill="none">
      <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M3 11V4.5A1.5 1.5 0 0 1 4.5 3H11"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ProfileMetaPanel({ lang, profile, onCopyUuid }) {
  const t = COPY[lang === 'zh' ? 'zh' : 'en'];

  const handleCopy = async () => {
    if (!profile?.uuid) return;
    try {
      await navigator.clipboard.writeText(profile.uuid);
      if (typeof onCopyUuid === 'function') {
        onCopyUuid(t.copied);
      }
    } catch (_) {
      // clipboard unavailable
    }
  };

  return (
    <div className="profile-v2-meta-panel">
      <div className="profile-v2-meta-row">
        <span className="profile-v2-meta-label">{t.userIdLabel}</span>
        <div className="profile-v2-meta-uuid">
          <code className="profile-v2-meta-value">{truncateUuid(profile.uuid)}</code>
          <button type="button" className="profile-v2-copy-btn" onClick={handleCopy} title={t.copy}>
            <CopyIcon />
            <span>{t.copy}</span>
          </button>
        </div>
      </div>
      <div className="profile-v2-meta-row">
        <span className="profile-v2-meta-label">{t.memberSinceLabel}</span>
        <span className="profile-v2-meta-value">{formatDateTime(profile.createTime, lang)}</span>
      </div>
      <div className="profile-v2-meta-row">
        <span className="profile-v2-meta-label">{t.lastUpdatedLabel}</span>
        <span className="profile-v2-meta-value">{formatDateTime(profile.updateTime, lang)}</span>
      </div>
    </div>
  );
}

export default ProfileMetaPanel;
